export default __webpack_public_path__ + "static/media/ci_202211.7cbcd0f7.png";